import Api from './Api';

class EmailApi extends Api {
  url = 'emails';
}

const singleton = new EmailApi();
export default singleton;
